import { render, staticRenderFns } from "./formfield.vue?vue&type=template&id=71b9da6a&scoped=true&lang=html"
import script from "./formfield.vue?vue&type=script&lang=js"
export * from "./formfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b9da6a",
  null
  
)

export default component.exports